// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTerms_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /lgpd_terms/delete
 */
import { registerContract } from './validate'

export interface LgpdTerms_DeleteInput {
id: number
}

registerContract('LgpdTerms_DeleteInput', {
  id: { type: 'number',  required: true },
})
